<template>
  <div class="data_dialog">
    <el-dialog
      :title="title"
      :before-close="cancelButton"
      :visible.sync="dialogVisible"
      max-width="80%"
    >
      <el-form :model="radio" :rules="rules" ref="radio" label-width="100px" class="demo-dataForm">
        <div class="english">
          <el-form-item label="Name_EN:" prop="englishName" class="input_name">
            <el-input
              v-model="radio.ENName"
              auto-complete="off"
              placeholder="Please enter Company English Name"
              maxlength="50"
              @blur="EnnameBlur"
            ></el-input>
          </el-form-item>
        </div>

        <el-form-item label="Name_CN:" prop="chineseName">
          <el-input
            v-model="radio.ZHName"
            auto-complete="off"
            maxlength="50"
            placeholder="Please enter Company chinese Name"
            @blur="CnnameBlur"
          ></el-input>
        </el-form-item>
        <el-form-item label="Abbreviation:" prop="abbreviation">
          <div class="add_abbreviation">
            <el-input
              auto-complete="off"
              placeholder="Please enter abbreviation"
              v-for="(item,i) in abbreviationArray"
              :key="i"
              v-model="item.key"
            ></el-input>
            <div class="add_button">
              <el-button size="mini" icon="el-icon-plus" circle @click="addInput"></el-button>
              <el-button size="mini" icon="el-icon-minus" circle @click="cutInput"></el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="Email:" prop="email">
          <el-input v-model="radio.email" auto-complete="off" placeholder="Please enter email"></el-input>
        </el-form-item>
        <el-form-item label="Tel:" prop="tel">
          <el-input v-model="radio.telephone" auto-complete="off" placeholder="Please enter tel"></el-input>
        </el-form-item>
        <el-form-item label="Website:" prop="website">
          <el-input v-model="radio.website" auto-complete="off" placeholder="Please enter website"></el-input>
        </el-form-item>
        <el-form-item label="Introduction:" prop="introduction">
          <el-input
            type="textarea"
            v-model="radio.introduction"
            auto-complete="off"
            placeholder="Please enter a introduction"
          ></el-input>
        </el-form-item>
        <el-form-item label="Industry:" prop="industry">
          <el-select v-model="radio.industry" placeholder="Please enter industry">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Group:" prop="groupId">
          <el-select v-model="radio.groupId" placeholder="Please enter group">
            <el-option v-for="item in group" :key="item.id" :label="item.ENName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="State:" prop="status">
          <el-radio v-model="radio.status" label="1">On</el-radio>
          <el-radio v-model="radio.status" label="0">Off</el-radio>
        </el-form-item>
        <el-form-item label="Address:" prop="address">
          <el-input v-model="radio.address" auto-complete="off" placeholder="Please enter address"></el-input>
        </el-form-item>
        <el-form-item label="Logo:" prop="file">
          <!-- <input type="button" id="btn" value="选择文件" />
            <span id="text" ref="textItem">未选择任何文件</span>
            <div class="file_input">
              <input type="file" id="fileinp" ref="fileinp" @change="getFile($event)" />
          </div>-->
          <a href="javascript:void(0);" class="input">
            上传图片
            <input type="file" class="file" @change="getFile($event)" accept />
          </a>
          <span id="text" ref="textItem">未选择任何文件</span>
          <div class="error_word" v-show="isError">只能上传为jpg、jpeg、png、gif的格式</div>

          <!-- <input type="file" @change="getFile($event)" ref="Picture" /> -->
        </el-form-item>
        <el-form-item class="button">
          <el-button type="primary" @click="submitForm('radio')">Submit</el-button>
          <el-button @click="resetForm('radio')">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  industry,
  testEnglish,
  testChinese,
  companyGroup
} from "@/common/js/http/version3Api.js";

export default {
  props: ["passVisible", "title", "editCompany", "isAdd"],
  name: "dataDialog",
  data() {
    var englishName = (rule, value, callback) => {
      if (this.repeatEnglish === "") {
        callback(new Error("企业名称不能为空"));
      } else {
        testEnglish({
          id: this.radio.id,
          companyName: this.repeatEnglish
        }).then(res => {
          if (res.result) {
            callback(new Error("英文名称重复"));
          } else {
            callback();
          }
        });
      }
    };
    var chineseName = (rule, value, callback) => {
      if (this.repeatChinese === "") {
        callback(new Error("企业名称不能为空"));
      } else {
        testChinese({
          id: this.radio.id,
          companyName: this.repeatChinese
        }).then(res => {
          if (res.result) {
            callback(new Error("中文名称重复"));
          } else {
            callback();
          }
        });
      }
    };
    var fileInput = (rule, value, callback) => {
      if (!this.isWorld && this.$refs.textItem.innerHTML === '未选择任何文件') {
        callback(new Error("必选"));
      } else {
        callback();
      }
    };
    return {
      isWorld: false,
      isError: false,
      radio: {
        id: "",
        ENName: "",
        ZHName: "",
        abbreviation: "",
        email: "",
        telephone: "",
        website: "",
        introduction: "",
        industry: "",
        groupId: "",
        address: "",
        file: "",
        status: "1"
      },
      repeatEnglish: "",
      repeatChinese: "",
      fileFlag: true,
      dialogVisible: false,
      number: 1,
      abbreviationArray: [
        {
          id: 1,
          key: ""
        }
      ],
      abbreArray: [],
      nextArray: [],
      newId: "",
      newKey: "",
      options: [],
      group: [],
      editLogoName: "",
      rules: {
        englishName: [
          { required: true, validator: englishName, trigger: "blur" }
        ],
        chineseName: [
          { required: true, validator: chineseName, trigger: "blur" }
        ],
        industry: [
          {
            required: true,
            message: "Industry cannot be empty",
            trigger: "change"
          }
        ],
        groupId: [
          {
            required: true,
            message: "Group cannot be empty",
            trigger: "change"
          }
        ],

        // status: [{required: true, message: "必选", trigger: "change"}],
        file: [{ required: true, validator: fileInput, trigger: "change" }]
      }
    };
  },
  created() {
    this.radio.id = "";
    //行业列表
    this.getIndustry();
    this.getCompanyGroup();
  },
  mounted() {},
  methods: {
    //失去焦点 英文
    EnnameBlur() {
      this.repeatEnglish = this.radio.ENName;
    },
    CnnameBlur() {
      this.repeatChinese = this.radio.ZHName;
    },
    //减少input框
    cutInput() {
      this.number--;
      if (this.number === 0) {
        this.number = 1;
        this.abbreviationArray = this.abbreviationArray;
      } else {
        this.abbreviationArray.splice(
          this.abbreviationArray.indexOf(this.number),
          1
        );
      }
    },
    //点击添加input框
    addInput() {
      this.number++;
      this.abbreviationArray.push({
        id: this.number,
        key: ""
      });
    },
    //文本域
    getFile(event) {
      this.radio.file = event.target.files[0];

      if (event.target.files.length > 0) {
        var testmsg = event.target.files[0].name.substring(
          event.target.files[0].name.lastIndexOf(".") + 1
        );
        const test = testmsg === "jpg";
        const test2 = testmsg === "png";
        const test3 = testmsg === "jpeg";
        const test4 = testmsg === "gif";
        if (!test && !test2 && !test3 && !test4) {
          this.isError = true;
        } else {
          this.isError = false;
        }
        if (event.target.files[0].size > 5 * 1024 * 1024) {
          this.$message({
            message: "上传的文件不能大于5M",
            type: "warning"
          });
          this.radio.file = "";
        }
      }
      if (event.target.files !== null && event.target.files.length > 0) {
        this.$nextTick(() => {
          this.$refs.textItem.innerHTML = event.target.files[0].name;
          if (this.$refs.textItem.innerHTML !== "未选择任何文件") {
            this.isWorld = true;
          } else {
            this.isWorld = false;
          }
        });
      }

      if (!this.isAdd) {
        event.target.files[0].name = this.editCompany[0].logoName;
      }
    },
    cancelButton() {
      this.resetForm("radio");
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.isAdd) {
            this.nextArray = [];
            this.abbreviationArray.filter((item, index) => {
              this.nextArray.push(item.key);
              this.radio.abbreviation = this.nextArray.join("、");
            });
          } else {
            this.nextArray = [];
            this.abbreviationArray.filter((item, index) => {
              this.nextArray.push(item.key);
              this.radio.abbreviation = this.nextArray.join("、");
            });
          }
          let formData = new FormData();
          formData.append("id", this.radio.id);
          formData.append("ENName", this.radio.ENName);
          formData.append("ZHName", this.radio.ZHName);
          formData.append("abbreviation", this.radio.abbreviation);
          formData.append("email", this.radio.email);
          formData.append("telephone", this.radio.telephone);
          formData.append("website", this.radio.website);
          formData.append("introduction", this.radio.introduction);
          formData.append("industryId", this.radio.industry);
          formData.append("groupId", this.radio.groupId);
          formData.append("address", this.radio.address);
          formData.append("status", this.radio.status);
          formData.append("file", this.radio.file);
          formData.append("brandToken", localStorage.getItem("brand-token"));
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(255, 255, 255, 0.9)"
          });
          setTimeout(() => {
            loading.close();
          }, 2000);
          this.$emit("submitForm", formData);
          this.resetForm("radio");
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.$emit("visible", false);
    },
    getIndustry() {
      industry().then(res => {
        this.options = res.result;
      });
    },
    getCompanyGroup() {
      companyGroup().then(res => {
        this.group = res.result;
      });
    }
  },
  watch: {
    radio(vals) {},
    passVisible(val) {
      this.dialogVisible = val;
    },
    editCompany(newValue) {
      if (newValue.length > 0) {
        this.radio.id = newValue[0].id;
        this.radio.ENName = newValue[0].ENName;
        this.radio.ZHName = newValue[0].ZHName;
        this.repeatEnglish = newValue[0].ENName;
        this.repeatChinese = newValue[0].ZHName;
        this.radio.abbreviation = newValue[0].abbreviation;
        this.radio.email = newValue[0].email;
        this.radio.telephone = newValue[0].telephone;
        this.radio.website = newValue[0].website;
        this.radio.introduction = newValue[0].introduction;
        this.radio.industry = newValue[0].industryId;
        this.radio.groupId = newValue[0].groupId;
        this.radio.address = newValue[0].address;
        this.radio.status = newValue[0].status.toString();
        this.editLogoName = newValue[0].logoName;
        if (!this.isAdd) {
          this.radio.file = newValue[0].logoName;
        }
        if (this.passVisible === true) {
          this.$nextTick(() => {
            this.$refs.textItem.innerHTML = this.editLogoName;
          });
        }
        if (this.radio.abbreviation !== null) {
          const newsArray = this.radio.abbreviation.split("、");
          this.number = newsArray.length;
          this.abbreArray = newsArray;
          this.nextArray = [];
          this.abbreviationArray = [];
          this.abbreArray.map((item, i) => {
            this.abbreviationArray.push({
              id: i + 1,
              key: item
            });
          });
        } else {
          this.abbreviationArray = [
            {
              id: 1,
              key: ""
            }
          ];
        }
      } else {
        this.radio.id = "";
        this.radio.ENName = "";
        this.radio.ZHName = "";
        this.radio.abbreviation = "";
        this.radio.email = "";
        this.radio.telephone = "";
        this.radio.website = "";
        this.radio.introduction = "";
        this.radio.industry = "";
        this.radio.groupId = "";
        this.radio.address = "";
        this.radio.status = "1";
        this.radio.file = "";
        this.repeatChinese = "";
        this.repeatEnglish = "";
        if (this.passVisible === true) {
          this.$nextTick(() => {
            this.$refs.textItem.innerHTML = "未选择任何文件";
          });
        }

        this.abbreviationArray = [
          {
            id: 1,
            key: ""
          }
        ];
      }
    }
  }
};
</script>

<style scoped>
.data_dialog >>> .english >>> .el-form-item__label {
  width: 160px;
}

.data_dialog >>> .el-form-item__content .el-input__inner {
  height: 32px;
  line-height: 32px;
}

.data_dialog >>> .el-input {
  width: 90%;
}

.data_dialog >>> .button .el-form-item__content button {
  height: 32px;
  line-height: 32px;
  padding: 0 20px;
}

.data_dialog >>> .el-form-item__content {
  margin-left: 120px !important;
}

.data_dialog >>> .el-form-item__label {
  width: 120px !important;
}

.data_dialog >>> .button {
  text-align: right;
  margin-bottom: 0;
}

.data_dialog >>> .el-dialog__body {
  padding-top: 10px;
}

.permission {
  height: 150px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.add_abbreviation {
  width: 100%;
  position: relative;
}

.add_abbreviation >>> .el-input {
  width: 90%;
  padding-right: 20px;
}

.add_button {
  width: 15%;
  display: inline-block;
  position: absolute;
  top: 0;
}

.add_button >>> .el-button {
  padding: 8px !important;
}

label {
  position: relative;
}

#text {
  font-size: 12px;
}

#btn {
  padding: 3px 6px;
  border-radius: 2px;
  margin-right: 5px;
}

.file_input >>> #fileinp {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

a.input {
  width: 70px;
  height: 30px;
  vertical-align: top;
  line-height: 30px;
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
  background: #409eff;
  color: #fff;
  margin: 5px 10px 0px 0px;
  border-radius: 5px;
  top: -4px;
}

.file {
  opacity: 0;
  filter: alpha(opacity=0);
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
}

.error_word {
  color: #f00;
}
</style>